/* ==========================================================================
   TRCO Cart Drawer — behaviour (native UpCart replacement) · part A of 4
   Travel Ring Co · Dawn theme
   v3 (Oct 2026): discount-code savings shown on line items exactly like
   compare-at savings. Split into 4 files (a–d, loaded in order by
   snippets/trco-cart-drawer.liquid) because the Shopify API caps a single
   file upload at ~16K characters. Shared state lives on window.__trco.
   Part A: config, helpers, controller constructor, init, static bindings.
   ========================================================================== */
(function () {
  'use strict';

  var cfgEl = document.getElementById('trco-cart-config');
  if (!cfgEl) return;
  var CONFIG;
  try { CONFIG = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function url(path) { return (ROOT + path).replace(/([^:]\/)\/+/g, '$1'); }

  /* ---- money ------------------------------------------------------------ */
  function formatMoney(cents, format) {
    format = format || CONFIG.moneyFormat || '${{amount}}';
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents2 = parts[1] ? decimal + parts[1] : '';
      return dollars + cents2;
    }
    var match = format.match(placeholder);
    if (!match) return format;
    var value;
    switch (match[1]) {
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(placeholder, value);
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function sizedImg(src, size) {
    if (!src) return '';
    return src.replace(/(\.(?:jpg|jpeg|png|gif|webp))(\?|$)/i, '_' + size + 'x$1$2');
  }
  function sameCode(a, b) { return String(a || '').toLowerCase() === String(b || '').toLowerCase(); }

  var TAG_ICON = '<svg viewBox="0 0 24 24" width="12" height="12" aria-hidden="true"><path d="M3 12V4a1 1 0 0 1 1-1h8l9 9-9 9-9-9z" stroke="currentColor" stroke-width="1.6" fill="none" stroke-linejoin="round"/><circle cx="7.5" cy="7.5" r="1.5" fill="currentColor"/></svg>';

  /* ---- ajax helpers ----------------------------------------------------- */
  function getJSON(path) {
    return fetch(url(path), { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }
  function postJSON(path, body) {
    return fetch(url(path), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  /* ==========================================================================
     Controller
     ========================================================================== */
  function Ctrl(el) {
    this.el = el;
    this.cart = null;
    this.compareCache = {};   // variantId -> compareAt cents
    this.productCache = {};   // handle -> product.js
    this.timerInterval = null;
    this._noteTimer = null;
    this._loading = false;
    this.upsellProducts = {};      // handle -> normalized product for display
    this._upsellMap = null;        // { default:[], byHandle:{} }
    this._upsellMapPromise = null;
    this._lastItemsHTML = null;    // last rendered line-items HTML (skip identical rewrites -> no flicker)
    this._lastUpsellHTML = null;   // last rendered upsell HTML
    this._discountError = null;    // code the customer just tried that Shopify rejected
    this.init();
  }

  Ctrl.prototype.$ = function (sel) { return this.el.querySelector(sel); };

  Ctrl.prototype.init = function () {
    this.itemsEl = this.$('[data-trco-items]');
    this.upsellsEl = this.$('[data-trco-upsells]');
    this.upsellListEl = this.$('[data-trco-upsell-list]');
    this.emptyEl = this.$('[data-trco-empty]');
    this.footerEl = this.$('[data-trco-footer]');
    this.timerEl = this.$('[data-trco-timer]');
    this.timerTextEl = this.$('[data-trco-timer-text]');
    this.checkoutTextEl = this.$('[data-trco-checkout-text]');
    this.noteEl = this.$('[data-trco-note]');
    this.addonEl = this.$('[data-trco-addon]');
    this.addonToggle = this.$('[data-trco-addon-toggle]');
    this.discountInput = this.$('[data-trco-discount]');
    this.discountStatus = this.$('[data-trco-discount-status]');

    this.applyColors();
    this.applyCopy();
    this.bindStatic();
    this.refresh(false);   // prime state quietly
  };

  Ctrl.prototype.applyColors = function () {
    var c = CONFIG.colors || {};
    var map = {
      '--trco-bg': c.background, '--trco-accent': c.accent, '--trco-btn': c.button,
      '--trco-btn-text': c.buttonText, '--trco-text': c.text, '--trco-savings': c.savings,
      '--trco-timer-bar': c.timerBar, '--trco-timer-text': c.timerText
    };
    for (var k in map) { if (map[k]) this.el.style.setProperty(k, map[k]); }
  };

  Ctrl.prototype.applyCopy = function () {
    var copy = CONFIG.copy || {};
    var set = function (sel, txt) { var e = this.$(sel); if (e) e.textContent = txt || ''; }.bind(this);
    set('[data-trco-upsell-heading]', copy.upsellHeading);
    set('[data-trco-notes-toggle] span', copy.notesToggle);
    set('[data-trco-discount-apply]', copy.discountApply || 'Apply');
    set('[data-trco-empty-text]', copy.emptyCart);
    set('.trco-cart__continue', copy.continueShopping);
    if (this.noteEl) this.noteEl.placeholder = copy.notesPlaceholder || '';
    if (this.discountInput) this.discountInput.placeholder = copy.discountPlaceholder || '';

    var addon = CONFIG.addon || {};
    set('[data-trco-addon-title]', addon.title);
    set('[data-trco-addon-desc]', addon.description);
    var ai = this.$('[data-trco-addon-img]');
    if (ai && addon.image) { ai.src = addon.image; ai.alt = addon.title || ''; }
  };

  Ctrl.prototype.bindStatic = function () {
    var self = this;
    this.el.querySelectorAll('[data-trco-close]').forEach(function (elc) {
      elc.addEventListener('click', function (e) { e.preventDefault(); self.close(); });
    });
    document.addEventListener('keyup', function (e) {
      if (e.key === 'Escape' && self.el.classList.contains('is-open')) self.close();
    });

    var checkoutBtn = this.$('[data-trco-checkout]');
    if (checkoutBtn) checkoutBtn.addEventListener('click', function () { window.location.href = url('checkout'); });

    if (this.noteEl) this.noteEl.addEventListener('input', function () {
      clearTimeout(self._noteTimer);
      self._noteTimer = setTimeout(function () { postJSON('cart/update.js', { note: self.noteEl.value }); }, 600);
    });

    if (this.addonToggle) this.addonToggle.addEventListener('change', function () { self.toggleAddon(this.checked); });

    var applyBtn = this.$('[data-trco-discount-apply]');
    if (applyBtn) applyBtn.addEventListener('click', function () { self.applyDiscount(); });
    if (this.discountInput) {
      this.discountInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); self.applyDiscount(); }
      });
      // Clear a "not valid" message as soon as the customer starts retyping.
      this.discountInput.addEventListener('input', function () {
        if (self._discountError) { self._discountError = null; self.renderDiscount(self.cart); }
      });
    }

    // delegated interactions
    this.el.addEventListener('click', function (e) {
      var dec = e.target.closest('[data-trco-dec]');
      var inc = e.target.closest('[data-trco-inc]');
      var rm = e.target.closest('[data-trco-remove]');
      var add = e.target.closest('[data-trco-upsell-add]');
      var rmCode = e.target.closest('[data-trco-remove-discount]');
      if (dec) self.changeLine(dec.getAttribute('data-key'), parseInt(dec.getAttribute('data-qty'), 10) - 1);
      else if (inc) self.changeLine(inc.getAttribute('data-key'), parseInt(inc.getAttribute('data-qty'), 10) + 1);
      else if (rm) self.changeLine(rm.getAttribute('data-key'), 0);
      else if (add) self.addUpsell(add);
      else if (rmCode) self.removeDiscount(rmCode.getAttribute('data-trco-remove-discount'));
    });
  };

  window.__trco = {
    CONFIG: CONFIG, url: url, formatMoney: formatMoney, esc: esc, pad: pad, sizedImg: sizedImg,
    sameCode: sameCode, TAG_ICON: TAG_ICON, getJSON: getJSON, postJSON: postJSON, Ctrl: Ctrl
  };
})();